import React, { useState,useEffect } from "react";
import CompanyNavbar from "./CompanyNavbar";
import Cookies from "js-cookie";
import ReactPaginate from "react-paginate";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
function ResignationRequestsCompany() {
        const ID = Cookies.get("log_id");
        const [requests,setRequests] = useState([]);
        function Fetch_Resignation_Requests() {
            axios.get(`${url.path}/fetch_resignation_requests/${ID}/`)
            .then((res) =>{
                if(res.data.status){
                    var emp = res.data.requests;
                    setRequests([])
                    emp.map((e)=>{
                        setRequests((prevState)=>[
                            ...prevState, e
                        ])
                    })
                }
            }).catch((err) => {
                console.log("ERROR", err);
              });
        }
        useEffect(() =>{
            Fetch_Resignation_Requests();
        }, [])
        const itemsPerPage = 3;
        const [searchTerm, setSearchTerm] = useState("");
        const [currentPage, setCurrentPage] = useState(0);
    
        const filteredData = requests.filter((item) =>
          item.employee.toLowerCase().includes(searchTerm.toLowerCase())
        );
    
        const offset = currentPage * itemsPerPage;
        const currentItems = filteredData.slice(offset, offset + itemsPerPage);
        const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    
        const handlePageClick = ({ selected }) => {
          setCurrentPage(selected);
        };
        function searchTable(){
          var rows = document.querySelectorAll('#productstable tbody tr');
          var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
          rows.forEach(function(row) {
            var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
            row.style.display = text.includes(val) ? '' : 'none';
          });
        }
        const [employee,setEmployee] = useState(null);
        const [status,setStatus] = useState("");
        const [reason,setReason] = useState("");
        const [Notice,setNotice] = useState("");
        const ApproalDisModal = (val,i) =>{
            setEmployee(i);
            setStatus(val);
        };
        const closeModal = () =>{
          setEmployee(null);
          setStatus(null);
          setNotice(null);
          setReason(null);
        };
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
          },
        });
        function handleDecision(e) {
          e.preventDefault();
          const formdata = new FormData();
          formdata.append('id',ID);
          formdata.append('employee',employee.id);
          formdata.append('status',status);
          formdata.append('reason',reason);
          formdata.append('notice',Notice);
          axios.post(`${url.path}/resignation_request_decision/`,formdata)
          .then((res) =>{
            if(res.data.status){
                if (res.data.stat === 'Approved'){
                    Toast.fire({
                      icon:'success',
                      title:'Resignation Request Approved..'
                    })
                } else if (res.data.stat === 'Rejected'){
                  Toast.fire({
                    icon:'warning',
                    title:'Resignation Request Rejected..'
                  })
                }
                closeModal();
                Fetch_Resignation_Requests();
            }
          }).catch((err) => {
            console.log("ERROR", err);
          });
        }
    return(
        <>
        <CompanyNavbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>Resignation Requests</h3>
            </center>
            <div className="search-container">
    <input
      type="text"
      placeholder="Search..."
      onKeyUp={searchTable}
      className="search-input"
      id="search"
    />
  </div>
        <div className="table-container">
            
      <table className="responsive-table" id="productstable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Name</th>
            <th>Email</th>
            <th>Contact</th>
            <th>Reason</th>
            <th>Designation</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.employee}</td>
              <td>{i.email}</td>
              <td>{i.contact}</td>
              <td>{i.reason}</td>
              <td>{i.designation}</td>
              {i.status === 'Pending' ? (
                <td>
                <button type="button" style={{width:'80px',backgroundColor:'green',color:'white',borderRadius:'5px'}} onClick={() =>ApproalDisModal("Approved",i)}>Approve</button>
              <button type="button" style={{width:'100px',backgroundColor:'red',color:'white',borderRadius:'5px',marginLeft:'5px'}} onClick={() =>ApproalDisModal("Rejected",i)}>Disapprove</button>
              </td>
              ) : (
                <td>
                    {i.status}
            </td>
              )}
                
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
    {employee && (
    <div className="modal-overlay" onClick={closeModal}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="close-button"
          onClick={closeModal}
        >
          &times;
        </button>
        <h2>Resignation Request Decision</h2>
        <form onSubmit={handleDecision}>
          {status === 'Rejected' ? (
            <div className="form-group-row"  id="requestDiv">
            <div className="form-group" >
              <label>Reason</label>
              <input type="text" value={reason} onChange={(e) =>setReason(e.target.value)} />
            </div>
          </div>
          ): (
            <div className="form-group-row">
            <div className="form-group" >
              <label>Notice Period(days)</label>
              <input type="number" value={Notice} onChange={(e) =>setNotice(e.target.value)} />
            </div>
          </div>
          )}
          <center>
          <button type="submit" style={{width:'100px',backgroundColor:'gainsboro',borderRadius:'5px'}}>Submit</button>
          </center>
        </form>
      </div>
    </div>
  )}
        </>
    );
}
export default ResignationRequestsCompany;